import { BehaviourSettingServices } from './../BehaviourSetting.services'
import { StateServices } from './../state.services'
import { Injectable } from '@angular/core'
import { ActivatedRoute, CanDeactivate, Router } from '@angular/router'
import { ComponentCanDeactivate } from './component-can-deactivate'
import { ModalService } from '../modal.service'
import { SharedServices } from '../shared.services'
import { AuthService } from '../auth.services'
import { notification } from 'onsenui'


@Injectable()
export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {
    statusSaveOption
    statusSaveForm
    statusSaveMail
    statusSaveCommon
    statusDiscard
    statusNewRoom
    statusNewClient
    statusDiscardNew
    statusSave
    routerLink
    statusRoom
    statusCompilece
    comPliceConfirm: string
    idClient
    en = {}
    showEN = true
    page
    statusValidateProfile = true

    constructor(private _sharedService: SharedServices,
                private route: ActivatedRoute,
                private modalservice: ModalService,
                private router: Router,
                private authData: AuthService,
                private stateServices: StateServices,
                private behaviourSettingServices: BehaviourSettingServices) {
        this._sharedService.changeEmitted$.subscribe(
            success => {
                if (success === 'activeAlertSaveMail') {
                    this.statusSaveMail = true
                } else if (success === 'activeAlertSaveCommon') {
                    this.statusSaveCommon = true
                } else if (success === 'cancelCommon') {
                    this.statusSaveCommon = false
                } else if (success && success[0] === 'activeAlertSaveComplice') {
                    this.statusCompilece = true
                    this.idClient = success[1]
                    this.comPliceConfirm = success[2]
                } else if (success === 'activeAlertNewRoom') {
                    this.statusNewRoom = true
                } else if (success === 'discardNewRoom') {
                    this.statusNewRoom = false
                } else if (success === 'activeAlertEditRoom') {
                    this.statusRoom = true
                } else if (success && success[0] === 'activeAlertNewClient') {
                    this.statusNewClient = true
                    this.page = success[1]
                    this.idClient = success[2]
                } else if (success === 'statusDiscard') {
                    this.statusDiscard = true
                    this.modalservice.emitChange('hiddenThenSaveMail')
                } else if (success === 'statusDiscardNew') {
                    this.statusDiscardNew = true
                } else if (success === 'saveMail') {
                    this.statusSave = true
                    this.modalservice.emitChange('hiddenThenSaveMail')
                } else if (success === 'saveNewRoom') {
                    this.statusSave = true
                } else if (success === 'saveNewClient') {
                    this.statusSave = true
                } else if (success === 'setRoutes') {
                    this.statusDiscard = false
                    this.statusNewClient = false
                } else if (success && success[0] === 'checkRotesLink') {
                    this.routerLink = success[1]
                } else if (success === 'activeAlertSaveOption') {
                    this.statusSaveOption = true
                } else if (success === 'activeAlertSaveForm') {
                    this.statusSaveForm = true
                } else if (success === 'savebehaviorSetting') {
                    this.statusSave = true
                } else if (success && success === 'valid-profile') {
                    this.statusValidateProfile = false
                } else if (success && success === 'unvalid-profile') {
                    this.statusValidateProfile = true
                }
            })
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    canDeactivate(component: ComponentCanDeactivate): boolean {

        if (this.statusDiscard === true) {
            this.statusDiscard = false
            this.statusSaveMail = false
            this.statusCompilece = false
            this.statusNewRoom = false
            this.statusNewClient = false
            this.statusSaveOption = false
            this.statusSaveForm = false
            this.modalservice.emitChange('hiddenThenSaveNew')
            return true
        }
        if (this.statusSave === true) {
            this.statusDiscard = false
            this.statusSaveMail = false
            this.statusCompilece = false
            this.statusNewRoom = false
            this.statusSave = false
            this.statusNewClient = false
            this.statusSaveOption = false
            this.statusSaveForm = false
            return true
        }
        if (this.statusSaveMail === true) {
            this.modalservice.emitChange('showMoadlMail')
            return false
        }
        if(!this.checkTimeout()){
            this.statusSaveCommon = false
            this.statusNewClient = false
            this.statusCompilece = false
        }
        if (this.statusCompilece === true) {
            this.changeLanguage()
            notification.confirm({
                message: this.en['alert-content'],
                title: this.en['alert-title'],
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], this.en['alert-discard'], this.en['alert-save']],
                modifier: 'rowfooter',
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        this.statusCompilece = false
                        this.router.navigateByUrl('/app/main/client/edit/' + this.idClient + '/' + this.routerLink)
                    } else if (i === 2) {
                        this.statusCompilece = false
                        const arrayConfirmCompliece = ['saveComplianceOrthoPulse', this.comPliceConfirm]
                        this._sharedService.emitChangeParent(arrayConfirmCompliece)
                        this.router.navigateByUrl('/app/main/client/edit/' + this.idClient + '/' + this.routerLink)
                    }
                },
            })
            return false
        }
        if (this.statusSaveCommon === true) {
            this.changeLanguage()
            notification.confirm({
                message: this.en['alert-content'],
                title: this.en['alert-title'],
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], this.en['alert-discard'], this.en['alert-save']],
                modifier: 'rowfooter',
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        this.statusSaveCommon = false
                        this.router.navigateByUrl('/app/main/setting/' + this.routerLink)
                        return true
                    } else if (i === 2) {
                        this.statusSaveCommon = false
                        this.router.navigateByUrl('/app/main/setting/' + this.routerLink)
                        this._sharedService.emitChangeParent('saveComon')
                        return true
                    }
                },
            })
            return false
        }
        if (this.statusSaveOption === true || this.statusSaveForm === true) {
            this.changeLanguage()
            const enableBehavior = this.stateServices.returnEnableBehavior()
            if (enableBehavior == 'true') {
                notification.confirm({
                    message: this.en['alert-content'],
                    title: this.en['alert-title'],
                    cancelable: true,
                    buttonLabels: [this.en['alert-cancel'], this.en['alert-discard'], this.en['alert-save']],
                    modifier: 'rowfooter',
                    callback: i => {
                        if (i === 1) {  // here this is not cancelled.  1 is correct.
                            this.statusSaveOption = false
                            this.statusSaveForm = false
                            this.behaviourSettingServices.emitChangeJsonBehaviorSetting(null)
                            this.behaviourSettingServices.emitChangeOptionSetting(null)
                            this.router.navigateByUrl('/app/main/setting/' + this.routerLink)
                            return true
                        } else if (i === 2) {
                            this.statusSaveOption = false
                            this.statusSaveForm = false
                            this.behaviourSettingServices.emitChangeJsonBehaviorSetting(null)
                            this.behaviourSettingServices.emitChangeOptionSetting(null)
                            this.router.navigateByUrl('/app/main/setting/' + this.routerLink)
                            this._sharedService.emitChangeParent('saveOption')
                            return true
                        }
                    },
                })
                // enable behaviour by user
            } else {
                this.statusSaveOption = false
                this.statusSaveForm = false
                this.behaviourSettingServices.emitChangeJsonBehaviorSetting(null)
                this.behaviourSettingServices.emitChangeOptionSetting(null)
                return true
            }
            return false
        }
        if (this.statusNewClient === true) {
            // this.modalservice.emitChange('activeAlertNewClientPage');
            this.changeLanguage()
            notification.confirm({
                message: this.en['alert-content'],
                title: this.en['alert-title'],
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], this.en['alert-discard'], this.en['alert-save']],
                modifier: 'rowfooter',
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        this.statusNewClient = false
                        this._sharedService.emitChange('statusDiscard')
                        // this._sharedService.emitChange('activeAlertSaveMail');
                        if (this.routerLink.indexOf('app') != -1) {
                            if (this.page == 'profile') {
                                this.router.navigateByUrl(this.routerLink)
                            } else {
                                if (this.routerLink.indexOf('search') != -1) {
                                    this.router.navigateByUrl('/app/main/client/' + this.routerLink)
                                } else {
                                    this.router.navigateByUrl(this.routerLink)
                                }
                            }
                        } else {
                            if (this.page == 'profile') {
                                this.router.navigateByUrl('/app/main/client/edit/' + this.idClient + '/' + this.routerLink)
                            } else {
                                if (this.routerLink.indexOf('search') != -1) {
                                    this.router.navigateByUrl('/app/main/client/' + this.routerLink)
                                } else {
                                    this.router.navigateByUrl(this.routerLink)
                                }
                            }
                        }
                        return true
                    } else if (i === 2) {
                        if (!this.statusValidateProfile) {
                            notification.confirm({
                                message: this.en['alert-validate'],
                                title: this.en['alert-title'],
                                cancelable: true,
                                buttonLabels: this.en['alert-cancel'],
                                modifier: 'rowfooter',
                            })
                            this._sharedService.emitChange('statusCancel')
                        } else {
                            this.statusNewClient = false
                            this._sharedService.emitChange(['saveNewClient', this.page])
                            if (this.routerLink.indexOf('app') != -1) {
                                if (this.page == 'profile') {
                                    this.router.navigateByUrl(this.routerLink)
                                } else {
                                    if (this.routerLink.indexOf('search') != -1) {
                                        this.router.navigateByUrl('/app/main/client/' + this.routerLink)
                                    } else {
                                        this.router.navigateByUrl(this.routerLink)
                                    }
                                }
                            } else {
                                if (this.page == 'profile') {
                                    this.router.navigateByUrl('/app/main/client/edit/' + this.idClient + '/' + this.routerLink)
                                } else {
                                    if (this.routerLink.indexOf('search') != -1) {
                                        this.router.navigateByUrl('/app/main/client/' + this.routerLink)
                                    } else {
                                        this.router.navigateByUrl(this.routerLink)
                                    }
                                }
                            }
                            return true
                        }
                    } else {
                        this._sharedService.emitChange('statusCancel')
                    }
                },
            })
            return false
        }
        if (this.statusNewRoom === true) {
            // this.modalservice.emitChange('activeAlertNewRoomm');
            this.changeLanguage()
            notification.confirm({
                message: this.en['alert-content'],
                title: this.en['alert-title'],
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], this.en['alert-discard'], this.en['alert-save']],
                modifier: 'rowfooter',
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        this.statusNewRoom = false
                        this.router.navigateByUrl('/app/main/communication/' + this.routerLink)
                        return true
                    } else if (i === 2) {
                        this.statusNewRoom = false
                        this.router.navigateByUrl('/app/main/communication/' + this.routerLink)
                        this._sharedService.emitChange('saveNewRoom')
                        return true
                    }
                },
            })
            return false
        }
        if (this.statusRoom === true) {
            this.modalservice.emitChange('activeAlertRoomm')
            return false
        }
        return true
    }

    checkTimeout() {
        if (this.authData.getItem('user')) {
            const user = JSON.parse(this.authData.getItem('user'));
            const expires = parseInt((user.expiresInSeconds)) * 1000;
            const timeOut = parseInt(this.authData.getItem('timeout')) + expires;
            const timeNow = Date.now();
            if(timeOut > timeNow){
                return true;
            }
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/guarad/pending-changes.guard.ts